import { render, staticRenderFns } from "./CommentInfoDialog.vue?vue&type=template&id=5d86ce79&"
import script from "./CommentInfoDialog.vue?vue&type=script&lang=js&"
export * from "./CommentInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports